import type {
  BigQueryUsageTenantBranding,
  BigQueryUsageTenantIdentity,
  BigQueryUsageTenantRef,
} from "@/features/bigquery-usage/api/bigquery-usage.api";

/**
 * Keyed by category as well as id, so the two special buckets — which both carry
 * a null id — never collapse into one entry.
 */
export function tenantBrandingKey(
  tenant: Pick<BigQueryUsageTenantIdentity, "kind" | "tenantId">,
): string {
  return `${tenant.kind}:${tenant.tenantId ?? ""}`;
}

/**
 * Branding per tenant, taken from the totals read. The timeseries repeats a
 * tenant once per bucket and carries no branding for exactly that reason, so the
 * chart's legend looks its logos up here instead of reading them off a band.
 */
export function buildTenantBranding(
  rows: readonly BigQueryUsageTenantRef[] | undefined,
): ReadonlyMap<string, BigQueryUsageTenantBranding> {
  const branding = new Map<string, BigQueryUsageTenantBranding>();
  for (const row of rows ?? []) {
    branding.set(tenantBrandingKey(row), {
      tenantName: row.tenantName,
      brandColor: row.brandColor,
      logoUrl: row.logoUrl,
    });
  }
  return branding;
}
